import { cn, Stack } from '@landler/component-library';
import { Progress } from 'component-library/Progress/Progress';
import { FC } from 'react';

import { Icon } from '../Icon/Icon';

type ProgressBarStyles = {
  root?: string;
  container?: string;
  indicator?: string;
  progress?: string;
};

type ProgressBarProps = {
  value: number;
  max?: number;
  icon?: string;
  styles?: ProgressBarStyles;
};

export const ProgressBar: FC<ProgressBarProps> = ({ value, max = 100, icon, styles = {} }) => {
  return (
    <Stack spacing={1} className={cn('w-full', styles.root)}>
      <Stack direction='row' className={cn('justify-between items-center', styles.container)}>
        <Stack direction='row' spacing={2} className='items-center'>
          {icon && <Icon icon={icon} className={cn(styles.indicator)} />}
        </Stack>
      </Stack>
      <Progress value={value} max={max} className={cn('bg-neutral-black-8', styles.progress)} />
    </Stack>
  );
};
